import axios from 'axios';
import { MarketId } from 'types/market-id.enum';

import { Contact } from 'views/settings/types/contact.type';

// GET
// /ewosapi/v1/customcontent/market/contacts
export const getMarketContacts = async (marketId: MarketId): Promise<Contact[]> => {
  const res = await axios.get<Contact[]>(`/ewosapi/v1/useradmin/Market/contacts/${marketId}`);
  return res.data;
};
